import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  toggleSize(): void {
    const classesToToggle = ['size-24', 'size-48', 'cursor-zoom-in', 'cursor-zoom-out']
    classesToToggle.forEach(className => {
      this.element.classList.toggle(className)
    })
  }
}
